import { render, staticRenderFns } from "./TeachingPaperDeptModal.vue?vue&type=template&id=700e7fc6"
import script from "./TeachingPaperDeptModal.vue?vue&type=script&lang=js"
export * from "./TeachingPaperDeptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports